import { render, staticRenderFns } from "./WvSteakHouseWineListItem.vue?vue&type=template&id=78a1c6f2&scoped=true"
import script from "./WvSteakHouseWineListItem.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseWineListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1c6f2",
  null
  
)

export default component.exports